/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './OpenFinanceVantagens.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function OpenFinanceVantagens() {
  return (
    <>
      <section id="open-finance-vantagens">
        <ContainerHome24>
          <h2 className="vantagens-titulo">Vantagens na hora de financiar seu veículo</h2>
          <div>
            <CustomEmblaCarouselHome24
              enableBullets
              detectBulletCount
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <img src="assets/open-finance/vantagens/ic_bank_credit.svg" alt="" />
                    <h3 className="slide-titulo">
                      Melhoria de perfil
                      <br />
                      de crédito
                    </h3>
                    <p className="slide-texto">Chance de uma entrada facilitada e taxas menores.</p>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/open-finance/vantagens/ic_security.svg" alt="" />
                    <h3 className="slide-titulo">
                      Seus dados
                      <br />
                      seguros
                    </h3>
                    <p className="slide-texto">
                      Seus dados só são compartilhados com o seu consentimento.
                    </p>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/open-finance/vantagens/ic_offer_discount.svg" alt="" />
                    <h3 className="slide-titulo">
                      Maior chance
                      <br />
                      de aprovação
                    </h3>
                    <p className="slide-texto">
                      É possível receber a aprovação mesmo após uma negativa.
                    </p>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default OpenFinanceVantagens;
